import styled from 'styled-components';
import { Link } from 'react-router-dom';

import { MOBILE_VIEWPORT, SMALL_VIEWPORT } from 'modules/theme/config';

export const FilterTitle = styled.span`
  margin-top: 16px;
  margin-bottom: 8px;
  color: ${({ theme }) => theme.colors.darkGrey};
  font-size: 16px;

  @media (max-width: ${SMALL_VIEWPORT}px) {
    font-size: 10px;
    margin-bottom: 4px;
  }
`;

export const FlexBoxContainer = styled.div`
  gap: 8px;
  padding: 4px;
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  margin-top: 12px;
  background-color: ${({ theme }) => theme.colors.backgroundAccent};
`;

export const FlexBoxItem = styled.div`
  display: flex;
  background-color: ${({ theme }) => theme.colors.white};
  padding: 16px 10px;
  border-radius: 12px;
  gap: 4px;

  @media (max-width: ${SMALL_VIEWPORT}px) {
    flex-direction: column;
    align-items: start;
  }
`;

export const RateContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex: 1;
  width: 100%;
  gap: 8px;
  justify-content: stretch;
`;

export const TimeBox = styled.div`
  display: flex;
  min-width: 130px;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
  padding-bottom: 8px;

  @media (max-width: ${SMALL_VIEWPORT}px) {
    align-items: start;
    width: 100%;
    flex-direction: row;
    justify-content: flex-start;
    gap: 16px;
  }
`;

export const TimeBlock = styled.span`
  display: inline-flex;
  align-items: baseline;

  h1 {
    line-height: 1;
    margin-bottom: 0;
  }

  span {
    padding-left: 2px;
    font-size: 14px;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.darkGrey};
  }
`;

export const PlayersBlock = styled.span`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const BestPrice = styled.div`
  gap: 4px;
  width: 100px;
  height: 24px;
  display: flex;
  padding: 4px 8px;
  align-items: center;
  border-radius: 20px;
  justify-content: center;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.red};
  @media (max-width: ${SMALL_VIEWPORT}px) {
    margin-left: auto;
  }
`;

export const RateBoxButton = styled.div`
  width: 45%;
  flex: 1 0 45%;
  cursor: pointer;
  padding: 8px 12px;
  align-items: center;
  border-radius: 12px;
  display: inline-flex;
  text-decoration: none;
  text-align: center;
  flex-direction: column;
  justify-content: center;
  transition: background-color 0.1s ease-out;
  color: ${({ theme }) => theme.colors.text};
  background-color: ${({ theme }) => theme.colors.lightGrey};
  position: relative;

  &.active {
    background-color: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.white};
    text-decoration: none;
    &::after {
      content: '';
      position: absolute;
      bottom: -8px;
      left: calc(50% - 8px);
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 8px 8px 0 8px;
      border-color: ${({ theme }) => theme.colors.primary} transparent transparent transparent;
    }
  }

  @media (max-width: ${SMALL_VIEWPORT}px) {
    border-radius: 6px;
    padding: 4px 8px;
  }
`;

export const RateBoxLink = styled(Link)`
  display: block;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 12px;
  text-decoration: none;
  text-align: center;
  transition: background-color 0.1s ease-out;
  background-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.white};
  text-decoration: none;
  &:hover {
    color: ${({ theme }) => theme.colors.white};
    text-decoration: none;
  }
  &[href='/'] {
    cursor: default;
    pointer-events: none;
  }

  @media (max-width: ${SMALL_VIEWPORT}px) {
    border-radius: 6px;
    padding: 6px 12px;
  }
`;

export const RateBoxEmpty = styled(RateBoxButton)`
  height: 0;
  padding: 0;
`;

export const RateBoxName = styled.span`
  font-size: 14px;
  line-height: 1.3;
  font-weight: 500;

  @media (max-width: ${MOBILE_VIEWPORT}px) {
    font-size: 12px;
  }
`;

export const RateBoxPrice = styled.span`
  font-weight: 500;
  font-size: 20px;
  line-height: 1.4;

  @media (max-width: ${MOBILE_VIEWPORT}px) {
    font-size: 16px;
  }
`;

export const RateBoxDescription = styled.div`
  display: block;
  background: ${({ theme }) => theme.colors.lightGrey};
  border: 1px solid ${({ theme }) => theme.colors.primary};
  padding: 12px;
  border-radius: 12px;
  width: 100%;
  & > p {
    margin-bottom: 8px;
  }
  @media (max-width: ${SMALL_VIEWPORT}px) {
    border-radius: 6px;
    padding: 8px;
  }
`;

